/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { without } from 'lodash';
import { SfCompletionCheckListItem } from '../../../resources/lead.model';

@Component({
  selector: 'gh-complete-sale-checklist-step',
  template: require('./complete-sale-checklist-step.component.html'),
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
})
export class CompleteSaleChecklistStepComponent {
  @Input() selected: ID[] = [];
  @Input() checks: SfCompletionCheckListItem[];

  @Output() selectedChange = new EventEmitter<ID[]>();

  isChecked(id: ID): boolean {
    return this.selected.includes(id);
  }

  onCheck(id: ID, checked: boolean): void {
    this.selectedChange.emit(checked ? this.selected.concat(id) : without(this.selected, id));
  }
}
